import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { VentasDiariasPorCostosPage } from '../../pages/ventas-diarias-por-costos/ventas-diarias-por-costos'
import { InformeBalanceNegocioPage } from '../../pages/informe-balance-negocio/informe-balance-negocio'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,VERSION,NOMBRE_VERSION,DESCRIPCION_VERSION } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InformeCantidadesDescontadasInventarioPorDiaPage } from '../../pages/informe-cantidades-descontadas-inventario-por-dia/informe-cantidades-descontadas-inventario-por-dia'
import { InformeProductosVendidosPorDiasPage } from '../../pages/informe-productos-vendidos-por-dias/informe-productos-vendidos-por-dias'
import { InformeDesperdiciosPorDiaPage } from '../../pages/informe-desperdicios-por-dia/informe-desperdicios-por-dia'
import { InformeCuadresDiariosPage } from '../../pages/informe-cuadres-diarios/informe-cuadres-diarios'
import { InformeExistenciasProductosActualesPage } from '../../pages/informe-existencias-productos-actuales/informe-existencias-productos-actuales'
import { InformeIngresoMercanciaPorDiaPage } from '../../pages/informe-ingreso-mercancia-por-dia/informe-ingreso-mercancia-por-dia'
import { InformeReimprimirReciboCajaPage } from '../../pages/informe-reimprimir-recibo-caja/informe-reimprimir-recibo-caja'
import { InformeVentasDevueltasPage } from '../../pages/informe-ventas-devueltas/informe-ventas-devueltas'
import { InformeCuentasPorCobrarPage } from '../../pages/informe-cuentas-por-cobrar/informe-cuentas-por-cobrar'
import { UtilsProvider } from '../../providers/utils/utils'
import { InformeGestionesPage } from '../informe-gestiones/informe-gestiones';


@IonicPage()
@Component({
  selector: 'page-reportes',
  templateUrl: 'reportes.html',
  providers: [ AuthService ]
})
export class ReportesPage {
  datosPagina:any[] = []
  datosPaginaReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public utils: UtilsProvider,
             public servicioCompania:CompaniasProvider) {
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })

                this.datosPagina = [
                    { "titulo":"Ventas","id":1},
                    { "titulo":"Balance","id":2},
                    { "titulo":"Productos","id":3},
                    { "titulo":"Gestión turnos","id":4}
                ]

                this.datosPaginaReal = [
                 {  "titulo":"Ventas diarias por costos","id":1,"nombre":"VentasDiariasPorCostosPage","ruta":"VentasDiariasPorCostosPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"analytics"},
                 {"titulo":"Balance general","id":2,"nombre":"InformeBalanceNegocioPage","ruta":"InformeBalanceNegocioPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {"titulo":"Cantidades vendidas descontadas del stock","id":3,"nombre":"InformeCantidadesDescontadasInventarioPorDiaPage","ruta":"InformeCantidadesDescontadasInventarioPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {"titulo":"Cantidades vendidas","id":3,"nombre":"InformeProductosVendidosPorDiasPage","ruta":"InformeProductosVendidosPorDiasPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {"titulo":"Desperdicios","id":3,"nombre":"InformeDesperdiciosPorDiaPage","ruta":"InformeDesperdiciosPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"beer"},
                 {"titulo":"Cuadre caja","id":3,"nombre":"InformeCuadresDiariosPage","ruta":"InformeCuadresDiariosPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"albums"},
                 {"titulo":"Existencia productos","id":3,"nombre":"InformeExistenciasProductosActualesPage","ruta":"InformeExistenciasProductosActualesPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"basket"},
                 {"titulo":"Ingreso mercancia","id":3,"nombre":"InformeIngresoMercanciaPorDiaPage","ruta":"InformeIngresoMercanciaPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"cart"},
                 {"titulo":"Reimprimir recibos de caja","id":1,"nombre":"InformeReimprimirReciboCajaPage","ruta":"InformeReimprimirReciboCajaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"copy"},
                 {"titulo":"Ventas devueltas","id":1,"nombre":"InformeVentasDevueltasPage","ruta":"InformeVentasDevueltasPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"return-left"},
                 {"titulo":"Cuentas por Cobrar","id":1,"nombre":"InformeCuentasPorCobrarPage","ruta":"InformeCuentasPorCobrarPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"briefcase"},
                 {"titulo":"turnos","id":4,"nombre":"InformeGestionesPage","ruta":"InformeGestionesPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"cart"}
                ]
               }else{

                 this.navCtrl.setRoot('PrincipalPage');
               }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportesPage');
  }
  abrirPaginaDesdeMenu(ruta:any,nombre:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        // this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
        this.utils.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique', 'warning')
      }else{
       this.irArutas(ruta)
       // this.menuControllers.close()
      }
    })
  }

  irArutas(ruta:any){
    switch(ruta){
      case "VentasDiariasPorCostosPage":
      this.navCtrl.push(VentasDiariasPorCostosPage)
      break;
      case "InformeBalanceNegocioPage":
      this.navCtrl.push(InformeBalanceNegocioPage)
      break;
      case "InformeCantidadesDescontadasInventarioPorDiaPage":
      this.navCtrl.push(InformeCantidadesDescontadasInventarioPorDiaPage)
      break;
      case "InformeProductosVendidosPorDiasPage":
      this.navCtrl.push(InformeProductosVendidosPorDiasPage)
      break;
      case "InformeDesperdiciosPorDiaPage":
      this.navCtrl.push(InformeDesperdiciosPorDiaPage)
      break;
      case "InformeCuadresDiariosPage":
      this.navCtrl.push(InformeCuadresDiariosPage)
      break;
      case "InformeExistenciasProductosActualesPage":
      this.navCtrl.push(InformeExistenciasProductosActualesPage)
      break;
      case "InformeIngresoMercanciaPorDiaPage":
      this.navCtrl.push(InformeIngresoMercanciaPorDiaPage)
      break;
      case "InformeReimprimirReciboCajaPage":
      this.navCtrl.push(InformeReimprimirReciboCajaPage)
      break;
      case "InformeVentasDevueltasPage":
      this.navCtrl.push(InformeVentasDevueltasPage)
      break;
      case "InformeCuentasPorCobrarPage":
      this.navCtrl.push(InformeCuentasPorCobrarPage)
      break;
      case "InformeGestionesPage":
        this.navCtrl.push(InformeGestionesPage)
        break;
    }
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/reportes/reportes.ts